import {
    SAVE_SIGNATURE_SUCCESS, SAVE_SIGNATURE_START, SAVE_SIGNATURE_FAILURE,
    FETCH_SIGNATURE_START, FETCH_SIGNATURE_SUCCESS, FETCH_SIGNATURE_FAILURE,
    FETCH_TWEETS_START, FETCH_TWEETS_SUCCESS, FETCH_TWEETS_FAILURE, FETCH_INSTAGRAM_START, 
    FETCH_INSTAGRAM_SUCCESS, FETCH_INSTAGRAM_FAILURE
} from "./SignatureActions";

const INITIAL_STATE = { fetching: false };

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case SAVE_SIGNATURE_START:
            return { ...state, fetching: true };
        case SAVE_SIGNATURE_SUCCESS:
            return { ...state, ...action.payload, fetching: false };
        case SAVE_SIGNATURE_FAILURE:
            return { ...state, ...action.payload, fetching: false };
        case FETCH_SIGNATURE_START:
            return { ...state, fetching: true };
        case FETCH_SIGNATURE_SUCCESS:
            return { ...state, ...action.payload, fetching: false };
        case FETCH_SIGNATURE_FAILURE:
            return { ...state, ...action.payload, fetching: false };
        case FETCH_TWEETS_START:
            return { ...state, fetching: true };
        case FETCH_TWEETS_SUCCESS:
            return { ...state, tweets: action.payload, fetching: false };
        case FETCH_TWEETS_FAILURE:
            return { ...state, error: action.payload, fetching: false };
        case FETCH_INSTAGRAM_START:
            return { ...state, fetching: true };
        case FETCH_INSTAGRAM_SUCCESS:
            return { ...state, instagramPost: action.payload, fetching: false };
        case FETCH_INSTAGRAM_FAILURE:
            return { ...state, error: action.payload, fetching: false };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/containers/signature/SignatureReducer.js